import { TTheme } from '@/core/theme'
import { styled } from '@mui/system'

export const Separator = styled('div')<{ theme?: TTheme }>`
    border: none;
    border-top: ${({ theme }) =>
        `dotted ${theme.colors.semantic.topPageSeparator} 4px`};
    height: 2px;
    width: 100%;
    margin: 30px 0;
`
